import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import dayjs from "dayjs";

@Component({
  selector: "app-growth-revision-filter-v2",
  templateUrl: "./growth-revision-filter-v2.component.html",
  styleUrls: ["./growth-revision-filter-v2.component.scss"],
})
export class GrowthRevisionFilterV2Component implements OnInit {
  dataViewFilterVisible = false;
  popoverOpen = false;
  dataviewApplied = false;
  radioValue = "";
  checkOptions = [];
  dvErrMsg = "";
  invalidDataview = false;
  customDate = null;
  inValidCustomDate = false;
  selectedDataView = "";
  @Input() dataview: any;
  @Input() disabled = false;
  @Input() growthOptions;
  @Input() revisionOptions;
  @Output() saveDataview = new EventEmitter();

  // constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.dataview &&
      changes.dataview.previousValue !== changes.dataview.currentValue
    ) {
      if (this.dataview && this.dataview["view_by"][0] !== "revision") {
        this.setCheckForGrowth();
      } else {
        this.setRadioForRevision();
      }
    }
  }

  /**
   * This method handles the opening and closing of the growth revision filter popover.
   *
   * The popover can be closed either using the apply button or clicking outside on the page.
   * This method deals with both the scenarios.
   */
  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (
      !this.radioValue &&
      !this.growthOptions[0].checked &&
      !this.growthOptions[1].checked
    ) {
      this.onResetDataView();
      this.invalidDataview = false;
      this.dvErrMsg = "";
    } else {
      this.invalidDataview = false;
      if (this.popoverOpen) {
        this.dataviewApplied = false;
      } else if (!this.popoverOpen && !this.dataviewApplied) {
        if (this.dataview && this.dataview["view_by"][0] !== "revision") {
          this.setCheckForGrowth();
        } else {
          this.setRadioForRevision();
        }
      }
    }
  }

  /**
   * This method resets the selection of the growth revision filter to the default values or the values that have been saved.
   */
  onResetDataView() {
    this.dataViewFilterVisible = false;
    if (this.dataview && this.dataview["view_by"][0] !== "revision") {
      this.setCheckForGrowth();
    } else {
      this.setRadioForRevision();
    }
  }

  chkboxOptChange() {
    this.radioValue = "";
  }

  /**
   * This is the onchange method for the ant radio component
   * where we set checked flag for each option
   * based on the selection made
   */
  radioValChange() {
    this.growthOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
  }

  /**
   * This method is fired on clicking the apply button.
   *
   *
   * This is useful to verify if ther user has made valid selections on the filter
   * before applying and sets the error message accordingly.
   *
   */
  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.growthOptions[0].checked &&
      !this.growthOptions[1].checked
    ) {
      this.invalidDataview = true;
      this.dvErrMsg = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        let dateStr = "";
        viewBy = ["revision"];
        if (this.radioValue === "custom") {
          if (this.customDate === null) {
            this.inValidCustomDate = true;
          } else {
            this.inValidCustomDate = false;
            dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
            this.selectedDataView = dateStr;
            revision = `custom|${dateStr}`;
          }
        } else {
          this.inValidCustomDate = false;
          revision = this.radioValue;
        }
        this.setDataView(revision, viewBy);
      } else {
        this.inValidCustomDate = false;
        this.customDate = "";
        if (this.growthOptions[0].checked && this.growthOptions[1].checked) {
          this.selectedDataView = "Values,YoY%";
          this.setDataView("", ["values", "yoy"]);
        } else {
          if (this.growthOptions[0].checked) {
            this.selectedDataView = this.growthOptions[0].label;
            this.setDataView("", ["values"]);
          }
          if (this.growthOptions[1].checked) {
            this.selectedDataView = this.growthOptions[1].label;
            this.setDataView("", ["yoy"]);
          }
        }
      }
    }
  }

  /**
   * This method is used to emit the value(output) of the filter as an input to the parent component.
   * @param revision revision value chosen by the user
   * @param viewBy either values or revision
   */
  setDataView(revision, viewBy) {
    if (!this.inValidCustomDate) {
      this.dataViewFilterVisible = false;
      this.dataviewApplied = true;
      this.saveDataview.emit({ viewBy, revision });
    }
  }

  setCheckForGrowth() {
    this.radioValue = "";
    for (let i = 0; i < 2; i++) {
      this.growthOptions[i].checked = this.dataview["view_by"].includes(
        this.growthOptions[i].value,
      )
        ? true
        : false;
    }
    if (this.dataview["view_by"].length < 2) {
      this.selectedDataView =
        this.dataview["view_by"][0] === "values" ? "Values" : "YoY%";
    } else {
      this.selectedDataView = "Values,YoY%";
    }
  }

  setRadioForRevision() {
    for (let i = 0; i < 2; i++) {
      this.growthOptions[i].checked = false;
    }
    if (this.dataview["revision"].startsWith("custom")) {
      this.radioValue = "custom";
      this.customDate = this.dataview["revision"].split("|")[1];
      this.selectedDataView = this.customDate;
    } else {
      this.radioValue = this.dataview["revision"];
      for (let i = 0; i < this.revisionOptions.length; i++) {
        if (this.revisionOptions[i].value === this.radioValue) {
          this.selectedDataView = `&Delta; ${this.revisionOptions[i].label}`;
          break;
        }
      }
    }
  }

  onDateChange() {
    if (this.customDate !== null) {
      this.inValidCustomDate = false;
    }
    this.radioValue = "custom";
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };
}
